import React from 'react';
import Banner from '../CommonComponents/Banner';
import HotelList from '../HotelComponents/HotelList';
import ComfortInn from "../assets/images/comfort-inn-hotels.webp";
import DaysInn from "../assets/images/day-inn.jpg";
import Super8 from "../assets/images/super-8.jpg";
import Eco from "../assets/images/Eco-Lodge2.webp";
import Travelodge from "../assets/images/Travelodge-Wyndham.jpg";
import Header from '../LayoutComponents/Header';
import Footer from '../LayoutComponents/Footer';
const BudgetHotels = () => {
  const budgetHotels = [
    {
      name: "Comfort Inn & Suites",
      image: ComfortInn,
      location: "Toronto, Ontario",
      overview: "Comfort Inn & Suites offers affordable and comfortable accommodations in Toronto, providing great value for budget-conscious travelers.",
      rooms: "The hotel features clean and comfortable rooms with free Wi-Fi, flat-screen TVs, and coffee makers. Rooms include basic amenities to ensure a pleasant stay.",
      dining: "Guests can enjoy a complimentary breakfast with a range of options including hot and cold items.",
      facilities: "The hotel offers a fitness center, business services, and on-site parking. The central location provides easy access to local attractions.",
      service: "The staff provide friendly and efficient service, ensuring a comfortable and budget-friendly stay.",
      experience: "Comfort Inn & Suites offers reliable and affordable accommodations in Toronto, making it a great choice for budget travelers."
    },
    {
      name: "Days Inn by Wyndham",
      image: DaysInn, 
      location: "Vancouver, British Columbia",
      overview: "Days Inn by Wyndham offers budget-friendly accommodations with a focus on comfort and convenience in Vancouver.",
      rooms: "The hotel's rooms feature basic amenities including free Wi-Fi, flat-screen TVs, and comfortable bedding. Rooms are designed to provide a pleasant stay without unnecessary frills.",
      dining: "Guests can enjoy a complimentary breakfast with a selection of continental items.",
      facilities: "The hotel includes a fitness center, business services, and parking. Its central location offers easy access to Vancouver's attractions.",
      service: "The staff are courteous and provide efficient service, ensuring a comfortable stay for budget-conscious travelers.",
      experience: "Days Inn by Wyndham offers practical and affordable accommodations in Vancouver, ideal for travelers seeking value and convenience."
    },
    {
      name: "Super 8 by Wyndham",
      image: Super8, 
      location: "Calgary, Alberta",
      overview: "Super 8 by Wyndham provides budget accommodations with essential amenities and a focus on comfort in Calgary.",
      rooms: "The hotel offers clean and functional rooms with free Wi-Fi, flat-screen TVs, and coffee makers. Rooms are equipped with basic amenities for a comfortable stay.",
      dining: "A complimentary breakfast is provided, including a selection of hot and cold options.",
      facilities: "The hotel features a fitness center, business services, and on-site parking. The central location offers easy access to Calgary's attractions.",
      service: "The staff deliver friendly and efficient service, ensuring a pleasant and budget-friendly stay.",
      experience: "Super 8 by Wyndham offers affordable and comfortable accommodations in Calgary, making it a solid choice for budget travelers."
    },
    {
      name: "Econo Lodge",
      image: Eco,
      location: "Ottawa, Ontario",
      overview: "Econo Lodge provides budget-friendly accommodations with essential amenities and a convenient location in Ottawa.",
      rooms: "The hotel's rooms feature free Wi-Fi, flat-screen TVs, and comfortable bedding. Rooms are designed for practicality and comfort.",
      dining: "Guests can enjoy a complimentary breakfast with a variety of options.",
      facilities: "The hotel includes a fitness center, business services, and on-site parking. Its central location offers easy access to local attractions.",
      service: "The staff provide courteous and efficient service, ensuring a comfortable stay for budget travelers.",
      experience: "Econo Lodge offers practical and affordable accommodations in Ottawa, making it a great choice for those seeking value and convenience."
    },
    {
      name: "Travelodge by Wyndham",
      image: Travelodge, 
      location: "Victoria, British Columbia",
      overview: "Travelodge by Wyndham offers budget accommodations with essential amenities and a focus on comfort in Victoria.",
      rooms: "The hotel features clean and comfortable rooms with free Wi-Fi, flat-screen TVs, and coffee makers. Rooms are designed to provide a pleasant stay.",
      dining: "A complimentary breakfast is available, offering a selection of hot and cold items.",
      facilities: "The hotel features a fitness center, business services, and on-site parking. Its convenient location provides easy access to Victoria's major attractions and landmarks.",
      service: "The staff are friendly and provide efficient service, ensuring a comfortable and affordable stay.",
      experience: "Travelodge by Wyndham offers reliable and budget-friendly accommodations in Victoria, ideal for travelers looking for value and comfort."
    }
  ];

  return (
    <>
    <Header />
      <Banner 
        title="Smart <span>Savings</span>: <span>Best Budget</span> Hotels in New Zealand"
        description="Discover **budget-friendly accommodations** in New Zealand with bluetidesolutions. Our reviews feature top-rated, **affordable hotels** that offer comfort, convenience, and great value. Whether you're traveling for business or leisure, find the best budget hotels that allow you to explore New Zealand without overspending. Enjoy cost-effective stays without compromising on quality."
      />
      <HotelList hotels={budgetHotels} />
            <Footer />
      
    </>
  );
};

export default BudgetHotels;